export default {
  frameFilter: {
    filterTitle: 'Filter',
  },
  frameLoop: {
    cycleIndex: 'Loop Times',
    title: 'Playback Settings',
    sequence: 'Times',
    LoopPlayback: 'Loop',
  },
  perFrameDrag: {
    addTitle: 'Add Image',
    playAction: 'Play sequence',
    stopAction: 'Pause Sequence',
    frameTitle: 'Image per frame',
    removeImageWarn: 'Sequence frame requires at least one picture',
    uploading: 'Uploading...',
  },
  perFrameInterval: {
    frameTitle: 'Delay per Frame',
  },
}
